{
  "titles": {
    "appointmentDetailsHaveChanged": "รายละเอียดการนัดหมายมีการเปลี่ยนแปลง",
    "appointmentScheduled": "นัดหมายแล้ว",
    "appointmentConfirmed": "ยืนยันการนัดหมายแล้ว",
    "appointmentRequested": "ส่งคำขอนัดหมายแล้ว",
    "missedAppointment": "ไม่มาตามนัดหมาย",
    "recurringAppointmentSeriesCreated": "สร้างชุดการนัดหมายซ้ำแล้ว",
    "truckArrivedAtFacility": "รถบรรทุกมาถึงสถานที่แล้ว",
    "appointmentIsInProgressAtFacility": "การนัดหมายกำลังดำเนินการที่สถานที่",
    "appointmentRescheduled": "เลื่อนการนัดหมายแล้ว",
    "appointmentCompleted": "การนัดหมายเสร็จสิ้น",
    "appointmentCancelled": "ยกเลิกการนัดหมายแล้ว",
    "appointmentTagged": "ติดแท็กการนัดหมายแล้ว",
    "assetReadyForPickup": "อุปกรณ์พร้อมให้รับแล้ว"
  },
  "subjects": {
    "appointmentDetailsHaveChanged": "รายละเอียดการนัดหมายมีการเปลี่ยนแปลง",
    "appointmentScheduled": "นัดหมายแล้วที่ {orgName} - {warehouseName}",
    "appointmentConfirmed": "ยืนยันการนัดหมายแล้วที่ {orgName} - {warehouseName}",
    "appointmentRequested": "ส่งคำขอนัดหมายแล้วที่ {orgName} - {warehouseName}",
    "missedAppointment": "ไม่มาตามนัดหมายที่ {orgName} - {warehouseName}",
    "recurringAppointmentSeriesCreated": "สร้างชุดการนัดหมายซ้ำเรียบร้อยแล้ว",
    "truckArrivedAtFacility": "รถบรรทุกมาถึง {orgName} - {warehouseName} แล้ว",
    "appointmentIsInProgressAtFacility": "การนัดหมายกำลังดำเนินการที่ {orgName} - {warehouseName}",
    "appointmentRescheduled": "เลื่อนการนัดหมายแล้วที่ {orgName} - {warehouseName}",
    "appointmentCompleted": "การนัดหมายเสร็จสิ้นที่ {orgName} - {warehouseName}",
    "appointmentCancelled": "ยกเลิกการนัดหมายกับ {orgName} - {warehouseName} แล้ว",
    "appointmentTagged": "ติดแท็กการนัดหมายเป็น {tagName} - {warehouseName}",
    "assetReadyForPickup": "พร้อมให้รับ - ตู้คอนเทนเนอร์ {containerNumber}"
  },
  "subTitles": {
    "appointmentDetailsHaveChanged": "โปรดตรวจสอบสถานที่ วันที่ เวลา และรายละเอียดทั้งหมดด้านล่าง",
    "appointmentScheduled": "โปรดตรวจสอบสถานที่ วันที่ เวลา และรายละเอียดทั้งหมดด้านล่าง",
    "appointmentConfirmed": "โปรดตรวจสอบสถานที่ วันที่ เวลา และรายละเอียดทั้งหมดด้านล่าง",
    "appointmentRequested": "โปรดรอการยืนยันจากคลังสินค้า",
    "missedAppointment": "ผู้ขนส่งไม่มาตามนัดหมาย",
    "recurringAppointmentSeriesCreated": "โปรดตรวจสอบรายละเอียดของการนัดหมายซ้ำด้านล่าง",
    "truckArrivedAtFacility": "ตรวจสอบสถานะและรายละเอียดการนัดหมายด้านล่าง",
    "appointmentIsInProgressAtFacility": "ตรวจสอบสถานะและรายละเอียดการนัดหมายด้านล่าง",
    "appointmentRescheduled": "ตรวจสอบสถานะและรายละเอียดการนัดหมายด้านล่าง",
    "appointmentCompleted": "ตรวจสอบสถานะและรายละเอียดการนัดหมายด้านล่าง",
    "appointmentCancelled": "โปรดตรวจสอบรายละเอียดทั้งหมดและเหตุผลในการยกเลิก",
    "appointmentTagged": "โปรดตรวจสอบชื่อแท็กและข้อมูลด้านล่าง",
    "assetReadyForPickup": "อุปกรณ์ที่สถานที่ของคุณพร้อมให้รับแล้ว"
  },
  "anchorLabels": {
    "appointmentDetailsHaveChanged": "ดูการนัดหมาย",
    "appointmentScheduled": "ดูการนัดหมาย",
    "appointmentConfirmed": "ดูการนัดหมาย",
    "appointmentRequested": "ดูการนัดหมาย",
    "missedAppointment": "ดูการนัดหมาย",
    "recurringAppointmentSeriesCreated": "ดูการนัดหมายต้นฉบับ",
    "truckArrivedAtFacility": "ดูการนัดหมาย",
    "appointmentIsInProgressAtFacility": "ดูการนัดหมาย",
    "appointmentRescheduled": "ดูการนัดหมาย",
    "appointmentCompleted": "ดูการนัดหมาย",
    "appointmentCancelled": "ดูการนัดหมาย",
    "appointmentTagged": "ดูการนัดหมาย",
    "assetReadyForPickup": "ดูการนัดหมาย"
  },
  "descriptions": {
    "appointmentTagged": "ใช้การตั้งค่าแท็กการนัดหมายเพื่อเปิดใช้งานแท็กแต่ละรายการ"
  },
  "contextLabels": {
    "assetReadyForPickup": {
      "schedulingAnchorLabel": "นัดหมายการรับสินค้า",
      "idLabel": "หมายเลขยืนยัน",
      "ownedByLabel": "เป็นของ:",
      "pickupScheduledForLabel": "นัดรับสินค้าในวันที่:",
      "noPickupScheduledLabel": "ยังไม่มีการนัดหมายรับสินค้า",
      "storeLabel": "ร้านค้า",
      "openInGoogleMapsLabel": "เปิดใน Google Maps",
      "appointmentDetailsLabel": "รายละเอียดการนัดหมาย",
      "loadTypeLabel": "ประเภทสินค้า",
      "warehouseInstructionsLabel": "คำแนะนำของคลังสินค้า",
      "amenitiesLabel": "สิ่งอำนวยความสะดวกที่มี",
      "ppeRequirementsLabel": "PPE และข้อกำหนดอื่น ๆ",
      "dockDoorLabel": "ประตูท่าเทียบรถ",
      "dockInstructionsLabel": "คำแนะนำของท่าเทียบรถ",
      "carrierContactLabel": "ผู้ติดต่อของผู้ขนส่ง"
    }
  }
}
